module.exports = __webpack_public_path__ + "af56b99113ccb065a9d2aa88a0417b40.png";